import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyB-R7jQ-a-tduYGWBYPjAVyVPMmrvkZ2bk',
  authDomain: 'procuzy-app.firebaseapp.com',
  databaseURL: 'https://procuzy-app-default-rtdb.firebaseio.com',
  projectId: 'procuzy-app',
  storageBucket: 'procuzy-app.appspot.com',
  messagingSenderId: '477051601307',
  appId: '1:477051601307:web:6ed5af0a288e18e4e6e13e',
  measurementId: 'G-FD0F7BMY5B',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const rtdb = getDatabase(app);
